module.exports = __webpack_public_path__ + "img/rw.559f166d.svg";